import { UserClient } from '@frontend/user/api';
import { IUser } from '@frontend/user/types';
import React, { useEffect, useState } from 'react';

export interface SelectedUserDetailsProps {
    user?: IUser | null;
    userId?: string | null;
}

export function getSelectedUserDetailLines(user: Pick<IUser, 'email' | 'mobile' | 'unique_identifier'>): string[] {
    const email = user.email?.trim() ?? '';
    const mobile = user.mobile?.trim() ?? '';
    const uniqueIdentifier = user.unique_identifier?.trim() ?? '';
    const lines: string[] = [];
    if (email) {
        lines.push(email);
    }
    if (mobile) {
        lines.push(mobile);
    }
    if (uniqueIdentifier && uniqueIdentifier !== email && uniqueIdentifier !== mobile) {
        lines.push(uniqueIdentifier);
    }
    return lines;
}

export const SelectedUserDetails = (props: SelectedUserDetailsProps) => {
    const [resolvedUser, setResolvedUser] = useState<IUser | null>(props.user ?? null);

    useEffect(() => {
        if (props.user) {
            setResolvedUser(props.user);
            return;
        }

        if (!props.userId) {
            setResolvedUser(null);
            return;
        }

        let cancelled = false;
        UserClient.resolveUsers([props.userId])
            .then((response) => {
                if (!cancelled) {
                    setResolvedUser(response.results[0] ?? null);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setResolvedUser(null);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.user, props.userId]);

    const lines = resolvedUser ? getSelectedUserDetailLines(resolvedUser) : [];
    if (lines.length === 0) {
        return null;
    }

    return (
        <div className='text-foreground-muted flex flex-col gap-0.5 text-sm'>
            {lines.map((line) => (
                <div key={line}>{line}</div>
            ))}
        </div>
    );
};
